var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("已分配客户")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "inquiry" },
      [
        _c("div", { staticClass: "header" }, [_vm._v("查询订单")]),
        _c(
          "el-form",
          {
            ref: "form",
            attrs: {
              inline: true,
              model: _vm.queryForm,
              "label-width": "",
              size: "mini",
            },
          },
          [
            _c("div", { staticClass: "selectDate" }, [
              _c("span", [_vm._v("时间")]),
              _c(
                "div",
                { staticClass: "picker" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy- MM- dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    on: { input: _vm.immediUpdate },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "el-form-item",
              { attrs: { label: "信息" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入客户手机号码/姓名" },
                  model: {
                    value: _vm.queryForm.info,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryForm, "info", $$v)
                    },
                    expression: "queryForm.info",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.searchEvent()
                      },
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchEvent.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("搜索")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { plain: "", loading: _vm.loading },
                    on: { click: _vm.reset },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "table" },
      [
        _c(
          "vxe-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData.list, align: "center" },
          },
          [
            _c("vxe-table-column", {
              attrs: { type: "index", title: "序号", width: "100" },
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "orderNo",
                title: "订单号",
                width: "100",
                "show-overflow": "",
              },
            }),
            _c("vxe-table-column", {
              attrs: {
                title: "客户姓名",
                "show-overflow": "",
                "min-width": "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.customerName))]),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "prodItem",
                title: "商品",
                "show-overflow": "",
                "min-width": "200",
              },
            }),
            _c("vxe-table-column", {
              attrs: { scope: "scope", title: "渠道", "min-width": "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.isAddCustomer == "N"
                        ? _c(
                            "el-select",
                            {
                              attrs: { placeholder: "选择渠道" },
                              model: {
                                value: scope.row.userDitch,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "userDitch", $$v)
                                },
                                expression: "scope.row.userDitch",
                              },
                            },
                            _vm._l(_vm.line, function (items) {
                              return _c("el-option", {
                                key: items.id,
                                attrs: { label: items.name, value: items.id },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      scope.row.isAddCustomer == "Y"
                        ? _c(
                            "el-select",
                            {
                              attrs: { placeholder: "选择渠道" },
                              model: {
                                value: scope.row.userDitch,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "userDitch", $$v)
                                },
                                expression: "scope.row.userDitch",
                              },
                            },
                            _vm._l(_vm.line, function (items) {
                              return _c("el-option", {
                                key: items.id,
                                attrs: {
                                  label: items.name,
                                  value: items.id,
                                  disabled: "",
                                },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: { title: "客服人员", "min-width": "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.isAddCustomer == "N"
                        ? _c(
                            "el-select",
                            {
                              attrs: { placeholder: "选择客服" },
                              model: {
                                value: scope.row.customerUserId,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "customerUserId", $$v)
                                },
                                expression: "scope.row.customerUserId",
                              },
                            },
                            _vm._l(_vm.customer, function (items) {
                              return _c("el-option", {
                                key: items.id,
                                attrs: {
                                  label: items.reallyName,
                                  value: items.id,
                                },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      scope.row.isAddCustomer == "Y"
                        ? _c(
                            "el-select",
                            {
                              attrs: { placeholder: "选择客服" },
                              model: {
                                value: scope.row.customerUserId,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "customerUserId", $$v)
                                },
                                expression: "scope.row.customerUserId",
                              },
                            },
                            _vm._l(_vm.customer, function (items) {
                              return _c("el-option", {
                                key: items.id,
                                attrs: {
                                  label: items.reallyName,
                                  value: items.id,
                                  disabled: "",
                                },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: {
                title: "资源时间",
                "show-overflow": "",
                "min-width": "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      !_vm.is_null(scope.row.orderTime)
                        ? _c("p", [
                            _vm._v(" " + _vm._s(scope.row.orderTime) + " "),
                          ])
                        : _c("p", [_vm._v("--")]),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "sourceFromName",
                title: "导入平台",
                width: "100",
              },
            }),
            _c("vxe-table-column", {
              attrs: { title: "操作", width: "120px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.parArray.indexOf("see") != -1
                        ? _c(
                            "p",
                            {
                              staticClass: "operation",
                              on: {
                                click: function ($event) {
                                  return _vm.tosee(scope.row)
                                },
                              },
                            },
                            [_vm._v(" 查看 ")]
                          )
                        : _vm._e(),
                      _vm.parArray.indexOf("see") != -1
                        ? _c(
                            "p",
                            {
                              staticClass: "operation",
                              on: {
                                click: function ($event) {
                                  return _vm.copyInfo(scope.row)
                                },
                              },
                            },
                            [_vm._v(" 复制 ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm.tableData.totalNum >= 1
      ? _c("div", { staticClass: "page" }, [
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage1,
                  "page-sizes": [10, 20, 50, 100, 200],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.totalNum,
                  "prev-text": "上一页",
                  "next-text": "下一页",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }